export default __webpack_public_path__ + "static/media/handleAndStrapWhite_diffuse-min.1fc08995.jpg";